import React from "react";
import "./ProfileSettingRow.css";

const ProfileSettingRow = ({
  expandHeight,
  icon,
  title,
  children,
  expanded,
  setExpanded,
  id,
}) => {
  return (
    <div
      className="profileSettingRow"
      style={expanded ? { height: expandHeight } : {}}
    >
      <div
        className="profileTitleRow"
        onClick={expanded ? () => setExpanded("") : () => setExpanded(id)}
      >
        <img className="settingsIcon" src={icon} alt="settingsIcon" />
        <h5
          className="settingTitle"
          style={expanded ? { color: "#74AD49" } : { color: "black" }}
        >
          {title}
        </h5>
      </div>
      <div className="settingContentWrapper">{expanded && children}</div>
    </div>
  );
};

export default ProfileSettingRow;
